import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchTalukas, deleteTaluka } from '../../utils/api';
import MasterDataTable from '../../components/MasterDataTable';

const columns = [
  { id: 'talukaId', label: 'ID', minWidth: 50 },
  { id: 'talukaName', label: 'Taluka Name', minWidth: 170 },
  { 
    id: 'district', 
    label: 'District', 
    minWidth: 170,
    format: (value) => value?.districtName || '-'
  },
  {
    id: 'state',
    label: 'State',
    minWidth: 170,
    format: (value, row) => row.district?.state?.stateName || '-'
  }
];

const TalukaList = ({ onEdit, searchQuery = '' }) => {
  const [talukas, setTalukas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadTalukas = async () => {
      setLoading(true);
      try {
        const response = await fetchTalukas();
        if (cancelled) return;
        setTalukas(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching talukas:', err);
        if (!cancelled) {
          setError('Failed to load talukas. Please try again later.');
          setTalukas([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadTalukas();
    return () => {
      cancelled = true;
    };
  }, [refreshTrigger]);

  const handleDelete = async (taluka) => {
    try {
      await deleteTaluka(taluka.talukaId, {
        previousData: taluka,
        identifier: taluka.talukaName
      });
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      console.error('Error deleting taluka:', err);
      alert('Failed to delete taluka. It may be referenced by other records.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Talukas
      </Typography>
      
      <MasterDataTable
        persistKey="taluka"
        data={talukas}
        columns={columns}
        isLoading={loading}
        searchQuery={searchQuery}
        onEdit={onEdit}
        onDelete={handleDelete}
        emptyMessage="No talukas found. Add your first taluka!"
      />
      
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default TalukaList; 